import { useState, useCallback } from "react";
import {
  createTravelItem,
  updateTravelItem,
  deleteTravelItem,
  type CreateTravelItemInput,
  type UpdateTravelItemInput,
} from "../services/travelItemService";

export function useCreateTravelItem() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateTravelItemInput) => {
    setLoading(true);
    setError(null);
    try {
      return await createTravelItem(input);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Create travel item failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useUpdateTravelItem() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = useCallback(
    async (
      travelItemId: string,
      eventId: string,
      input: UpdateTravelItemInput,
    ) => {
      setLoading(true);
      setError(null);
      try {
        await updateTravelItem(eventId, travelItemId, input);
      } catch (err) {
        const e =
          err instanceof Error ? err : new Error("Update travel item failed");
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { update, loading, error };
}

export function useDeleteTravelItem() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const remove = useCallback(async (travelItemId: string) => {
    setLoading(true);
    setError(null);
    try {
      await deleteTravelItem(travelItemId);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Delete travel item failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { remove, loading, error };
}
